import { API_REFERENCE } from '../utilities/constant_api';
import { selectmenuAccessibilityCompliance } from '../utilities/helper';
import { formPost, htmlPost, jsonPost } from './ajax';
import { zipCodeValidator } from '../utilities/utility';
$(function() {
  const validateCustomerAddressUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountDoctor.getCityStateNewPhysician}`;
  var addressData = $('.card-default').not('.new-card');
  var removingCard;
  var removingCardId;
  var updatingCardId;
  var editingCard;
  var curDefaultCard = false;
  var replacementCardArray;
  var addressLine1;
  var addressLine2;
  var name;
  var city;
  var state;
  var billingCheck;
  var shippingCheck;
  var zip;
  var careOf;
  var selectedCard;
  var addressType;
  var bReplaceWithNew = false;
  var numCards = 0;
  var isEditing = false;
  var isTempBilling = false;
  var isTempShipping = false;
  var isBillingChanged = false;
  var isShippingChanged = false;
  var newDefaultCheckedType;
  const clsPrefferredShippingAddress = '.prefferredShippingAddress';
  const clsBillingAddress = '.billingAddress';
  const clsErrorText = 'error';
  const clsExistingAddress = '.existing-addresses';
  const idRemoveAddressModal = '#removeAddressModal';
  let addressBookValidateAjaxReq = true;
  let addressBookRemoveAjaxReq = true;
  let addressBookReplaceAddressAjaxReq = true;
  let updateAddressBookReplaceAjaxReq = true;
  let submitAddressBookAjaxReq = true;
  let isValidZipVal = true;
  let isAddressLineVal = true;
  let isCityVal = true;

  function validateInput() {
    if ($(this).hasClass('insurance-radio')) {
      return;
    }
    if ($(this).parents('.dropdown').length == 0) {
      $(this)
        .next()
        .attr('hidden', true);
      $(this).removeClass(clsErrorText);
    } else {
      $(this)
        .parents('.dropdown')
        .find('.error-msg-text')
        .attr('hidden', true);
      $(this)
        .parents('.dropdown')
        .find('.ui-selectmenu-button')
        .removeClass(clsErrorText);
    }

    if ($(this).val() === '') {
      $(this)
        .next()
        .attr('hidden', false);
      $(this).addClass(clsErrorText);
    }
  }

  function inValidInput(e) {
    e.preventDefault();

    if (!e.target.validity.valid) {
      $(this)
        .next()
        .attr('hidden', false);
      $(this).addClass(clsErrorText);
      if (
        $(this).hasClass('new-address-zip-value') &&
        $(this)
          .val()
          .trim() === '' &&
        $(this).parents('.checkout-add-edit-address__form').length > 0
      ) {
        $(this)
          .parent()
          .find('.invalid-zip-code-paste')
          .attr('hidden', true);
      }
    }
    if (
      $(this).hasClass('new-address-zip-value') &&
      $(this)
        .val()
        .trim() !== '' &&
      $(this).parents('.checkout-add-edit-address__form').length > 0
    ) {
      $(this)
        .next()
        .attr('hidden', true);
    }
  }

  $("input[id='newadd']").on('click', function() {
    $(this).attr('checked', true);
    $(this).removeAttr('style');
  });

  function cancelState() {
    // eslint-disable-next-line spaced-comment
    $('.add-address-form').trigger('reset');
    $('.custom-input-valid')
      .next()
      .attr('hidden', true);
    $('.custom-input-valid').removeClass(clsErrorText);
    $('#cboxClose').click();
    setTimeout(function() {
      $('#colorbox')
        .removeClass('removeModal')
        .removeClass('removeReplaceModal')
        .removeClass('addEditModal')
        .removeClass('show');
    }, 500);
    if (
      $(this).hasClass('cancel-edit-address') &&
      $('#addressAction').val() === 'editAddress'
    ) {
      editingCard.find('.address-modifier_edit').focus();
    } else if (
      $(this).hasClass('cancel-edit-address') &&
      $('#addressAction').val() === 'addAddress'
    ) {
      $('.addNewAddress.add-address-btn').focus();
    }
  }

  $(document).on('click', '#cboxOverlay, #cboxClose', function() {
    if (
      !$(this).hasClass('coexistence-overlay') &&
      !$(this).hasClass('coexistence-cart-overlay-class') &&
      !$(this).hasClass('sms-phone-unsuscribe') &&
      !$(this).hasClass('sms-phone-savedViewUnsuscribe') &&
      !$(this).hasClass('exp-email-notification-overlay-main') &&
      !$(this).hasClass('email-notification-overlay-main')
    ) {
      dismissModal();
    }
  });

  function populateData() {
    addressLine1 = $('.card-address-line1', selectedCard).text();
    addressLine2 = $('.card-address-line2', selectedCard).text();
    name = $('.card-heading', selectedCard).text();
    city = $('.card-address-city', selectedCard).text();
    state = $('.card-address-state', selectedCard).text();
    zip = $('.card-address-zip', selectedCard).text();
    billingCheck = $('.billingCheck', selectedCard).text();
    shippingCheck = $('.shippingCheck', selectedCard).text();
    addressType = $('.addressType', selectedCard).text();
    careOf = $('.careOf', selectedCard).text();
  } // direct from card remove address modal (NOT COMING FROM EDIT SCREEN)

  function removeNewAddressData() {
    var removalTitle = 'Removing address';
    var bSimpleRemove = false;
    $('.replace-with-existing-address').prop('checked', true);
    selectedCard = this.parentElement.parentElement.parentElement.parentElement;
    removingCard = selectedCard.parentElement.parentElement;
    removingCardId = $(removingCard)
      .find('.card')
      .attr('data-cardid');
    populateData();

    if (billingCheck === 'false' && shippingCheck === 'false') {
      $('.remove-modal-singleAddress')
        .attr('id', 'removeAddress')
        .show();
      $('.remove-modal-multiAddress')
        .attr('id', '')
        .hide(); // if flag is false

      $('.dont-ask-again').show();
      bSimpleRemove = true; // if skip confirm is set previously

      if (window.localStorage.getItem('removeAddressConfirm') === 'false') {
        $('#dont-ask').prop('checked', true);
        doRemoveAddress(removingCardId);
        return false;
      }
    } else {
      if (billingCheck === 'true' && shippingCheck === 'true') {
        removalTitle =
          'You are removing your Primary Billing and Shipping address';
      } else if (billingCheck === 'true') {
        removalTitle = 'You are removing your Primary Billing address';
      } else if (shippingCheck === 'true') {
        removalTitle = 'You are removing your Primary Shipping address';
      }

      $('.remove-modal-multiAddress')
        .attr('id', 'removeAddress')
        .show();
      $('.remove-modal-singleAddress')
        .attr('id', '')
        .hide();
      $('.dont-ask-again').hide();
    } // if no other additional addresses

    if (numCards.length - 1 === 0) {
      // prompt next cta to add new default address
      $('.replace-with-existing-address')
        .removeClass('show')
        .addClass('hidden');
      $('.remove-adress--btn .btn-confirm')
        .html('Next')
        .attr('disabled', 'disabled');
      $('#newadd').prop('checked', false);
    } else {
      // if there are more than 1 address, generate a list of address to replace current default card
      $('.remove-adress--btn .btn-confirm').html('Save');
      $('.replace-with-existing-address')
        .removeClass('hidden')
        .addClass('show');
      replacementCardArray = $(
        '.card-default[data-cardid!="' + removingCardId + '"]'
      ).not('.new-card');
      var options = '';

      for (var i = 0; i <= replacementCardArray.length - 1; i++) {
        options +=
          "<option value='" +
          $(replacementCardArray[i]).attr('data-cardid') +
          "'>" +
          $(replacementCardArray[i])
            .find('.card-address')
            .text() +
          '</option>';
      }

      $(clsExistingAddress).html(options);
      $('.replace-with-existing-address')
        .removeClass('hidden')
        .addClass('show');
      $('input[value=existing-address]').prop('checked', true);

      if (bSimpleRemove == false) {
        $('.remove-adress--btn .btn-confirm').html('Submit');
      } else {
        $('.remove-adress--btn .btn-confirm').html('Remove');
      }
    }

    $('.remove-modal-name').text(name);
    $('.remove-modal-addressline1').text(addressLine1);
    $('.remove-modal-addressline2').text(addressLine2);
    $('.remove-modal-address-state').text(state, ',');
    $('.remove-modal-address-city').text(city, ',');
    $('.remove-modal-address-zip').text(zip); //Adding title as part of html

    $('.address-remove-modal__header').text(removalTitle);
    $.colorbox({
      href: idRemoveAddressModal,
      open: true,
      inline: true,
      close:
        '<span class="sr-only">Close button</span><span class="svg-icon_close svg-icon_close-dims close-icon-size-overlay" role="button" aria-label="close"></span>',
      width: '95%',
      maxWidth: '828px',
      className: 'remove-address-modal-wrapper',
      onComplete: function onComplete() {
        if (bSimpleRemove == false) {
          $('#colorbox')
            .removeClass('addEditModal')
            .removeClass('removeModal')
            .addClass('removeReplaceModal');
          $(idRemoveAddressModal)
            .addClass('remove-with-options')
            .removeClass('simple-remove');
        } else {
          $('#colorbox')
            .removeClass('addEditModal')
            .removeClass('removeReplaceModal')
            .addClass('removeModal');
          $(idRemoveAddressModal)
            .removeClass('remove-with-options')
            .addClass('simple-remove');
        }
        $('.existing-addresses').selectmenu();
      },
      onOpen: function() {
        setTimeout(function() {
          $('#colorbox').focus();
        }, 200);
      },
      onClosed: function onClosed() {
        $(removingCard)
          .find('.address-modifier_remove')
          .focus();
      }
    });
    $('.dismiss-modal').click(function() {
      dismissModal();
    });
  } // secondary modal from EDIT default address by UNCHECK BILLING/SHIPPING CHECKBOXES

  function editDefaultData() {
    var removalTitle;
    $('.replace-with-existing-address').prop('checked', true);
    populateData();

    if (newDefaultCheckedType == 'both') {
      removalTitle =
        'You are removing your Primary Billing and Shipping address';
    } else if (newDefaultCheckedType == 'billing') {
      removalTitle = 'You are removing your Primary Billing address';
    } else if (newDefaultCheckedType == 'shipping') {
      removalTitle = 'You are removing your Primary Shipping address';
    }

    $('.remove-modal-multiAddress')
      .attr('id', 'removeAddress')
      .show();
    $('.remove-modal-singleAddress')
      .attr('id', '')
      .hide();
    $('.dont-ask-again').hide(); // if no other additional addresses

    if (numCards.length - 1 === 0) {
      // prompt next cta to add new default address
      $('.replace-with-existing-address')
        .removeClass('show')
        .addClass('hidden');
      $('.remove-adress--btn .btn-confirm')
        .html('Next')
        .attr('disabled', 'disabled');
    } else {
      // if there are more than 1 address, generate a list of address to replace current default card
      $('.remove-adress--btn .btn-confirm').html('Save');
      $('.replace-with-existing-address')
        .removeClass('hidden')
        .addClass('show');
      replacementCardArray = $(
        '.card-default[data-cardid!="' + removingCardId + '"]'
      ).not('.new-card');
      var options = '';

      for (var i = 0; i <= replacementCardArray.length - 1; i++) {
        options +=
          "<option value='" +
          $(replacementCardArray[i]).attr('data-cardid') +
          "'>" +
          $(replacementCardArray[i])
            .find('.card-address')
            .text() +
          '</option>';
      }

      $(clsExistingAddress).html(options);
      $('.replace-with-existing-address')
        .removeClass('hidden')
        .addClass('show');
      $('input[value=existing-address]').prop('checked', true);

      {
        $('.remove-adress--btn .btn-confirm').html('Save');
      }
    }

    $('.remove-modal-name').text(name);
    $('.remove-modal-addressline1').text(addressLine1);
    $('.remove-modal-addressline2').text(addressLine2);
    $('.remove-modal-address-state').text(state, ',');
    $('.remove-modal-address-city').text(city, ',');
    $('.remove-modal-address-zip').text(zip); //Adding title as part of html

    $('.address-remove-modal__header').text(removalTitle);
    $.colorbox({
      href: idRemoveAddressModal,
      open: true,
      inline: true,
      close:
        '<span class="sr-only">Close button</span><span class="svg-icon_close svg-icon_close-dims close-icon-size-overlay" role="button" aria-label="close"></span>',
      width: '95%',
      maxWidth: '828px',
      className: 'remove-address-modal-wrapper',
      onComplete: function onComplete() {
        {
          $('#colorbox')
            .removeClass('addEditModal')
            .removeClass('removeModal')
            .addClass('removeReplaceModal');
          $(idRemoveAddressModal)
            .addClass('remove-with-options')
            .removeClass('simple-remove');
        }
      },
      onClosed: function onClosed() {
        $(removingCard)
          .find('.address-modifier_edit')
          .focus();
      }
    });
    $('.dismiss-modal').click(function() {
      dismissModal();
    });
  }

  function dismissModal() {
    $.colorbox.close();
    $('#colorbox')
      .removeClass('addEditModal')
      .removeClass('removeReplaceModal')
      .removeClass('removeModal')
      .removeClass('show')
      .hide();
    $('#dont-ask').prop('checked', false);
  } // save button on removal/replace default modal

  $('.btn-confirm-address-removal').click(function() {
    // remove address
    if (!isEditing) {
      if ($('.replace-address-with-option').is(':visible')) {
        var replacementOption = $(
          'input[name=address-replacement]:checked'
        ).val();

        if (replacementOption == 'existing-address') {
          var replacementAddressId = $(clsExistingAddress).val();
          doRemoveReplaceAddress(removingCardId, replacementAddressId, false);
        } else {
          doRemoveAddNewAddress();
        }
      } else {
        doRemoveAddress(removingCardId);
      }
    } else {
      // removing default from edit screen
      var replacementOption = $(
        'input[name=address-replacement]:checked'
      ).val();

      if (replacementOption == 'existing-address') {
        var replacementAddressId = $(clsExistingAddress).val();
        doUpdateDefaultAddress(
          updatingCardId,
          replacementAddressId,
          newDefaultCheckedType,
          false
        );
      } else {
        doRemoveAddNewAddress();
      }
    }
  });

  function doRemoveAddress(addressIDRemove) {
    setSkipRemoveConfirmationModal();
    const removeAddressUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountAddressBook.removeAddress}?addressId=${addressIDRemove}`;
    if (!addressBookRemoveAjaxReq) return false;
    addressBookRemoveAjaxReq = false;
    formPost(removeAddressUrl)
      .then(data => {
        addressBookRemoveAjaxReq = true;
        if ($('#dont-ask').is(':checked')) {
          window.localStorage.setItem('removeAddressConfirm', false);
        }

        location.reload();
      })
      .catch(error => {
        addressBookRemoveAjaxReq = true;
      });
  }

  function doRemoveReplaceAddress(
    addressIDRemove,
    addressIDReplace,
    isCallingFromSubmitForm
  ) {
    const removeReplaceAddressUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountAddressBook.removeReplaceAddress}?removeAddressId=${addressIDRemove}&replaceAddressId=${addressIDReplace}`;
    if (!isCallingFromSubmitForm) {
      if (!addressBookReplaceAddressAjaxReq) return false;
      addressBookReplaceAddressAjaxReq = false;
    }
    htmlPost(removeReplaceAddressUrl)
      .then(data => {
        if (!isCallingFromSubmitForm) {
          addressBookReplaceAddressAjaxReq = true;
        } else {
          addressBookValidateAjaxReq = true;
        }
        location.reload();
      })
      .catch(error => {
        if (!isCallingFromSubmitForm) {
          addressBookReplaceAddressAjaxReq = true;
        } else {
          addressBookValidateAjaxReq = true;
          submitAddressBookAjaxReq = true;
        }
      });
  } // ROB to update - newDefaultCheckedType can be 'shipping, billing, or both'

  function doUpdateDefaultAddress(
    oldDefaultAddressID,
    newDefaultAddressId,
    newDefaultCheckedType,
    isCallingFromSubmitForm
  ) {
    var tempUrl = ''; // ROB, if there's no newDefaultCheckedType passed in, then copy the checkboxes over from the old address
    // if there are newDefaultCheckedType passed in, the in the replacement address, only set that specific one

    if (newDefaultCheckedType != null) {
      // this path is to handle copy over of default checkboxes to existing address
      tempUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountAddressBook.updateDefaultAddress}?oldDefaultAddressId=${oldDefaultAddressID}&newDefaultAddressId=${newDefaultAddressId}&newDefaultCheckedType=${newDefaultCheckedType}`;
    } else {
      // this path is to handle setting default checkboxes to newly added address
      tempUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountAddressBook.updateDefaultAddress}?oldDefaultAddressId=${oldDefaultAddressID}&newDefaultAddressId=${newDefaultAddressId}`;
    }
    if (!isCallingFromSubmitForm) {
      if (!updateAddressBookReplaceAjaxReq) return false;
      updateAddressBookReplaceAjaxReq = false;
    }
    formPost(tempUrl)
      .then(data => {
        if (!isCallingFromSubmitForm) {
          updateAddressBookReplaceAjaxReq = true;
        } else {
          addressBookValidateAjaxReq = true;
        }
        location.reload();
      })
      .catch(error => {
        if (!isCallingFromSubmitForm) {
          updateAddressBookReplaceAjaxReq = true;
        } else {
          addressBookValidateAjaxReq = true;
          submitAddressBookAjaxReq = true;
        }
      });
  } // shared by remove then add new default address, AND edit and replace with new address

  function doRemoveAddNewAddress(addressIDRemove) {
    // in this method, we need to create a new card first,
    // then without refreshing the page, we call doRemoveReplaceAddress with the newly create addressId
    // the reason for this is to prevent user from successfully removing but closing the add-new-address modal before
    // creating a new replacement
    // close remove modal
    $('#cboxClose').click();
    bReplaceWithNew = true; // open new address modal after .5sec

    setTimeout(function() {
      $('#addressAction').val('newAddress');
      $('.addNewAddress').click();
      waitForModalToDisplay(function() {
        $('#colorbox')
          .removeClass('removeModal')
          .removeClass('removeReplaceModal')
          .addClass('addEditModal');
        triggerResize();
        $('.new-address-type-value, .address-book-state-value').selectmenu();
        // when coming from remove default and replace with new address
        if (!isEditing) {
          if (billingCheck === 'true' && shippingCheck === 'true') {
            $(clsPrefferredShippingAddress)
              .prop('checked', true)
              .attr('disabled', true);
            $(clsBillingAddress)
              .prop('checked', true)
              .attr('disabled', true);
          } else if (billingCheck === 'true') {
            $(clsBillingAddress)
              .prop('checked', true)
              .attr('disabled', true);
          } else if (shippingCheck === 'true') {
            $(clsPrefferredShippingAddress)
              .prop('checked', true)
              .attr('disabled', true);
          }
        } else {
          // when coming from edit default and replace with new address, check which checkbox was changed,
          // then do the opposite of currentBilling/Shipping as these denotes what the original values was before it was changed
          if (isBillingChanged) {
            $(clsBillingAddress).prop('checked', true);
          }

          if (isShippingChanged) {
            $(clsPrefferredShippingAddress).prop('checked', true);
          }
        }
      }, 100);
    }, 250);
  }

  function remove() {
    $(removingCard.parentElement).addClass('displayNone');
  }

  function waitForModalToDisplay(doCallback, time) {
    // sometimes colorbox takes awhile to be visible on page,
    // loop until modal appears then hook up callback function
    if ($('#colorbox').is(':visible')) {
      doCallback();
      selectmenuAccessibilityCompliance();
      return;
    } else {
      setTimeout(function() {
        waitForModalToDisplay(doCallback, time);
        selectmenuAccessibilityCompliance();
      }, time);
    }
  } // edit address

  function editAddress() {
    isEditing = true;
    selectedCard = this.parentElement.parentElement.parentElement.parentElement;
    editingCard = $(selectedCard).parent();
    var selectedCardID = $(selectedCard)
      .parent()
      .attr('data-cardid');
    updatingCardId = selectedCardID;
    populateData();
    $('.addNewAddress').click();
    waitForModalToDisplay(fillInInfo, 100);

    function fillInInfo() {
      $('#addressAction').val('editAddress');
      var submitType = $('#addressAction').val();

      if (submitType == 'editAddress') {
        $('.addEditAddressForm').attr(
          'action',
          '/viewAddressbook/updateAddress'
        );
      }

      $('#colorbox')
        .removeClass('removeModal')
        .removeClass('removeReplaceModal')
        .addClass('addEditModal');
      $('.edit-address-title').text('Edit Address');
      $('#colorbox')
        .removeClass('removeModal')
        .removeClass('removeReplaceModal')
        .addClass('addEditModal')
        .remove('suggestedAddressModal');
      $(window).resize(); //Using fullname from a separate element if care of is present

      var tempName =
        careOf !== ''
          ? $('.address-book-name', selectedCard)
              .text()
              .replace(/(\r\n|\n|\r)/gm, '')
              .split(' ')
          : $('.card-name', selectedCard)
              .text()
              .replace(/(\r\n|\n|\r)/gm, '')
              .split(' ');
      var sanitizedName = '';

      for (var i = 0; i <= tempName.length - 1; i++) {
        tempName[i] = tempName[i].trim();
      }

      sanitizedName = tempName.join(' ');
      var stateAbbr = state;
      var camelType =
        addressType.charAt(0).toUpperCase() +
        addressType.slice(1).toLowerCase();
      $(
        'select.new-address-type-value,select.new-address-state-value'
      ).selectmenu();
      $('#chhAddressForm #addressId').val(selectedCardID);
      $('.new-address-addressline1').val(addressLine1);
      $('.new-address-addressline2').val(addressLine2);
      $('.new-address-city-value').val(city);
      $('.new-address-zip-value').val(zip);
      $('.new-address-careof-value').val(careOf);
      $('select.new-address-type-value')
        .val(camelType)
        .prop('selected', true);
      $('select.new-address-state-value')
        .val(stateAbbr)
        .prop('selected', true);
      $('select.new-address-type-value').selectmenu('refresh');
      $('select.new-address-state-value').selectmenu('refresh');
      if (numCards.length > 1) {
        if (billingCheck === 'true') {
          $(clsBillingAddress).prop('checked', true);
        } else if (billingCheck === 'false') {
          $(clsBillingAddress).prop('checked', false);
        }

        if (shippingCheck === 'true') {
          $(clsPrefferredShippingAddress)
            .prop('checked', true)
            .change();
        } else if (shippingCheck === 'false') {
          $(clsPrefferredShippingAddress).prop('checked', false);
        }
      } else {
        if (billingCheck === 'true') {
          $(clsBillingAddress)
            .prop('checked', true)
            .attr('disabled', true);
        } else if (billingCheck === 'false') {
          $(clsBillingAddress).prop('checked', false);
        }

        if (shippingCheck === 'true') {
          $(clsPrefferredShippingAddress)
            .prop('checked', true)
            .attr('disabled', true);
        } else if (shippingCheck === 'false') {
          $(clsPrefferredShippingAddress).prop('checked', false);
        }
      }

      if (shippingCheck === 'true' || billingCheck === 'true') {
        curDefaultCard = true;
      }

      isTempBilling = $(clsBillingAddress).is(':checked') ? 'true' : 'false';
      isTempShipping = $(clsPrefferredShippingAddress).is(':checked')
        ? 'true'
        : 'false';
    }
  }

  var currentBilling;
  var currentShipping; // swap Save button to Next if shipping/billing checkbox changed in edit modal

  $(document).on('change', '.addEditAddressForm .custom-checkbox', function() {
    if (curDefaultCard) {
      currentBilling = $(clsBillingAddress).is(':checked') ? 'true' : 'false';
      currentShipping = $(clsPrefferredShippingAddress).is(':checked')
        ? 'true'
        : 'false';

      if (
        isEditing &&
        (currentBilling != isTempBilling || currentShipping != isTempShipping)
      ) {
        // mark which checkbox was changed only if the changes are unchecked. if checked, treat it as update override
        if (currentBilling == 'false' && isTempBilling == 'true') {
          isBillingChanged = true;
        } else {
          isBillingChanged = false;
        }

        if (currentShipping == 'false' && isTempShipping == 'true') {
          isShippingChanged = true;
        } else {
          isShippingChanged = false;
        }

        if (
          $('#addnewaddress').length === 0 ||
          isBillingChanged == true ||
          isShippingChanged == true
        ) {
          $('.addEditModal #save-new-address').attr('name', 'edit-next');
        } else {
          $('.addEditModal #save-new-address').attr('name', 'edit-save');
        } //set type of change to use in case of a replace with existing address

        if (isBillingChanged == true && isShippingChanged == true) {
          newDefaultCheckedType = 'both';
        } else if (isBillingChanged == true) {
          newDefaultCheckedType = 'billing';
        } else {
          newDefaultCheckedType = 'shipping';
        }
      } else {
        $('.addEditModal #save-new-address').attr('name', 'edit-save');
      }
    }
  });

  function validateInformation() {
    let firstInvaild = null;
    var elements = document.getElementsByClassName('custom-input-valid');
    $.each(elements, function(i, e) {
      if (!e.validity.valid) {
        if (firstInvaild == null) {
          firstInvaild = i;
        }
        if ($(e).parents('.dropdown').length > 0) {
          $(e)
            .parents('.dropdown')
            .find('.error-msg-text')
            .attr('hidden', false);
          $(e)
            .parents('.dropdown')
            .find('.ui-selectmenu-button')
            .addClass(clsErrorText);
        } else {
          if (!isValidZipVal && $(e).val()) {
            $(e)
              .parent()
              .find('.invalid-zip-code-paste')
              .attr('hidden', false);
            $(e).addClass(clsErrorText);
          } else {
            $(e)
              .next()
              .attr('hidden', false);
            $(e).addClass(clsErrorText);
          }
        }
      }
    });
    if (firstInvaild !== null) {
      elements[firstInvaild].focus();
    }
  } // overriding Save button on addEdit modal
  // THIS IS ACTUAL SUBMIT firing for new/edit address form

  $(document).on('click', '.addEditAddressForm #save-new-address', function(e) {
    validateInformation();
    currentBilling = $(clsBillingAddress).val();
    currentShipping = $(clsPrefferredShippingAddress).val();
    var saveCondition = $('.addEditModal #save-new-address').attr('name');
    if (!isValidZipVal || !isAddressLineVal || !isCityVal) {
      e.preventDefault();
    }
    if (saveCondition === 'edit-next') {
      e.preventDefault();
      editDefaultData();
    }
  }); // add address

  function newAddressData(e) {
    e.stopPropagation();
    isEditing = false; // addModal is already called by jsp
    // this is not the real new address modal,
    // this is actually creating an ajax call to the server to create a new address id
    // then return an html form and attach it as content for a colorbox
    // this function is for carrying out other functions as a callback to when modal appears

    waitForModalToDisplay(setUpModal, 100);

    function setUpModal() {
      $(window).resize();
      $('#colorbox')
        .removeClass('removeModal')
        .removeClass('removeReplaceModal')
        .addClass('addEditModal');
      $('.new-address-type-value').val('Home');
      $('.new-address-addressline1-value').val('');
      $('.new-address-city-value').val('');
      $('.new-address-state-value').val('');
      $('.new-address-zip-value').val(''); // upon creating new address, if there are no other address, set this address to default shipping/billing & dont allow editing them
      $(
        'select.new-address-type-value,select.new-address-state-value'
      ).selectmenu();
      if (addressData.length <= 0) {
        $(clsBillingAddress)
          .prop('checked', true)
          .attr('disabled', true);
        $(clsPrefferredShippingAddress)
          .prop('checked', true)
          .attr('disabled', true);
      } else {
        $(clsPrefferredShippingAddress).removeAttr('disabled');
        $(clsBillingAddress).removeAttr('disabled');
      }
    }
  }

  function triggerResize() {
    // reset sizing for colorbox during dynamic creation
    $(window).resize();
  }
  /**
   * If there is a one to one match for the address entered with the address validation service, the address validation overlay should not be displayed to the user
   * One to one match is defined as all fields (Address line 1, Address line 2 - if applicable, City, State, Zip) match perfectly with the return address from the address validation service
   * Zip code match is defined as first 5 digits
   * If first 5 digits are a match, supplemental 4 digits will be added to the zip code
   * Country value is added to the address from the validation service
   * @param objAddress
   * @param CARESAddressResponse
   */

  var isDisplaySuggestedAddress = function isDisplaySuggestedAddress(
    enteredAddress,
    CARESAddressResponse
  ) {
    var displaySuggestedAddress = false;
    var zipSplit = CARESAddressResponse.zip.split('-')[0];
    var zipCode = enteredAddress.zipcode;

    if (CARESAddressResponse.message != '') {
      displaySuggestedAddress = true;
    } else if (
      !CARESAddressResponse.address1.trim() &&
      !CARESAddressResponse.address2.trim() &&
      !CARESAddressResponse.city.trim() &&
      !CARESAddressResponse.state.trim()
    ) {
      displaySuggestedAddress = true;
    } else if (
      enteredAddress.address1.toLowerCase() !==
      CARESAddressResponse.address1.toLowerCase()
    ) {
      displaySuggestedAddress = true;
    } else if (
      enteredAddress.address2.toLowerCase() !==
      CARESAddressResponse.address2.toLowerCase()
    ) {
      displaySuggestedAddress = true;
    } else if (
      enteredAddress.city.toLowerCase() !==
      CARESAddressResponse.city.toLowerCase()
    ) {
      displaySuggestedAddress = true;
    } else if (
      enteredAddress.state.toLowerCase() !==
      CARESAddressResponse.state.toLowerCase()
    ) {
      displaySuggestedAddress = true;
    } else if (
      zipCode.length > 5 &&
      enteredAddress.zipcode !== CARESAddressResponse.zip
    ) {
      displaySuggestedAddress = true;
    } else if (
      zipCode.length <= 5 &&
      enteredAddress.zipcode !== CARESAddressResponse.zip.split('-')[0]
    ) {
      displaySuggestedAddress = true;
    }

    return displaySuggestedAddress;
  };

  function showSuggestedAddress(objAddress, CARESAddressResponse) {
    $('#colorbox')
      .removeClass('removeModal')
      .removeClass('addEditModal')
      .addClass('suggestedAddressModal');
    $(window).resize(); // For resizing the address validation popup.

    $('.user-entered .name').text(objAddress.name);
    $('.user-entered .address1').text(objAddress.address1);
    $('.user-entered .address2').text(objAddress.address2);
    $('.user-entered .city').text(objAddress.city);
    $('.user-entered .state').text(objAddress.state);
    $('.user-entered .zipcode').text(objAddress.zipcode);
    $('.user-entered .rdi').text(objAddress.rdi);

    if (!CARESAddressResponse.statCode) {
      $('#suggestedAddressBlock > span.name').text(objAddress.name);
      $('#suggestedAddressBlock > span.address1').text(
        CARESAddressResponse.address1
      );
      $('#suggestedAddressBlock > span.address2').text(
        CARESAddressResponse.address2
      );
      $('#suggestedAddressBlock > span.city').text(CARESAddressResponse.city);
      $('#suggestedAddressBlock > span.state').text(CARESAddressResponse.state);
      $('#suggestedAddressBlock > span.zipcode').text(CARESAddressResponse.zip);
      $('#suggestedAddressBlock > span.rdi').text(CARESAddressResponse.rdi);
      $('button#btn-save-address').show();
      $('h4#isValidAddressHeader').text(addressValidationHeader);
      $('p#isValidAddressSub').text(addressValidationSubheader);
    } else if (/^\d+$/.test(CARESAddressResponse.statCode)) {
      $('h4#isValidAddressHeader').text(addressValidationErrorNotFoundHeader);
      $('p#isValidAddressSub').text(addressValidationErrorNotFoundSubheader);
      $('#suggestedAddressBlock >  span.country').text('');
    }
  }

  var processZip = function processZip(
    displaySuggestedAddress,
    enteredAddress,
    CARESAddressResponse
  ) {
    var retValue =
      !displaySuggestedAddress &&
      /[\d]{5}[\-][\d]{4}/.test(CARESAddressResponse.zip)
        ? CARESAddressResponse.zip
        : enteredAddress.zipcode;
    return retValue;
  };

  function validateAddress(e) {
    e.preventDefault();
    var customerAddress = {
      address1: $('.new-address-addressline1').val(),
      address2: $('.new-address-addressline2').val(),
      city: $('.new-address-city-value').val(),
      state: $('.new-address-state-value').val(),
      zipcode: $('.new-address-zip-value').val(),
      rdi: $('#rdiVal').val()
    };
    var CARESAddressRequest = {};
    CARESAddressRequest.address1 = customerAddress.address1;
    CARESAddressRequest.address2 = customerAddress.address2;
    CARESAddressRequest.city = customerAddress.city;
    CARESAddressRequest.state = customerAddress.state;
    CARESAddressRequest.zip = customerAddress.zipcode;
    CARESAddressRequest.state = customerAddress.state;
    CARESAddressRequest.rdi = customerAddress.rdi;
    var CARESAddressResponse = null;

    const validateCustomerData = JSON.stringify(CARESAddressRequest);
    if (!addressBookValidateAjaxReq) return false;
    addressBookValidateAjaxReq = false;
    jsonPost(validateCustomerAddressUrl, validateCustomerData)
      .then(data => {
        CARESAddressResponse = data;
        if (!$.trim(CARESAddressResponse)) {
          submitAddressForm($('#addressAction').val(), false);
        } else {
          var displaySuggestedAddress = isDisplaySuggestedAddress(
            customerAddress,
            CARESAddressResponse
          );

          {
            if (displaySuggestedAddress) {
              addressBookValidateAjaxReq = true;
              $('.modal-dialog').addClass('show-suggested-address');
              $('#addnewaddress').hide();
              $('#saveAddress').show();
              showSuggestedAddress(customerAddress, CARESAddressResponse);
              if (CARESAddressResponse.message != '') {
                $('.suggested-address-wrapper').addClass('hidden');
                $("input[name='address'][value='user-entered']").prop(
                  'checked',
                  true
                );
              }
            } else {
              $('.zip').val(
                processZip(
                  displaySuggestedAddress,
                  customerAddress,
                  CARESAddressResponse
                )
              );
              var action = $('#addressAction').val();
              submitAddressForm(action, false);
            }
          }
        }
      })
      .catch(error => {
        var action = $('#addressAction').val();
        submitAddressForm(action, false);
      });
  }

  function saveAddress() {
    var selectedAddress = $('.radio-address:checked').val();
    var selectedAddressObj = {
      name: $('.' + selectedAddress)
        .find('.name')
        .text(),
      address1: $('.' + selectedAddress)
        .find('.address1')
        .text(),
      address2: $('.' + selectedAddress)
        .find('.address2')
        .text(),
      city: $('.' + selectedAddress)
        .find('.city')
        .text(),
      state: $('.' + selectedAddress)
        .find('.state')
        .text(),
      zipcode: $('.' + selectedAddress)
        .find('.zipcode')
        .text(),
      country: $('.' + selectedAddress)
        .find('.country')
        .text(),
      rdi: $('.' + selectedAddress)
        .find('.rdi')
        .text()
    };
    $('#chhAddressForm')
      .find('input[name=line1]')
      .val(selectedAddressObj.address1);
    $('#chhAddressForm')
      .find('input[name=line2]')
      .val(selectedAddressObj.address2);
    $('#chhAddressForm')
      .find('input[name=townCity]')
      .val(selectedAddressObj.city);
    $('#chhAddressForm')
      .find('input[name=rdi]')
      .val(selectedAddressObj.rdi);

    if (
      /[\d]{5}/.test(selectedAddressObj.zipcode) &&
      /[\d]{5}[\-][\d]{4}/.test(
        $('#suggestedAddressBlock > span.zipcode').text()
      )
    ) {
      $('#chhAddressForm')
        .find('input[name=postcode]')
        .val($('#suggestedAddressBlock > span.zipcode').text());
    } else {
      $('#chhAddressForm')
        .find('input[name=postcode]')
        .val(selectedAddressObj.zipcode);
    }

    $('#chhAddressForm')
      .find('select[name=regionIso]')
      .val(selectedAddressObj.state); // submit

    var action = $('#addressAction').val();
    submitAddressForm(action, true);
  }

  function closeSaveAddressModal() {
    $('input.radio-address').prop('checked', false);
    $('#addNewAddress').show();
    $('#addnewaddress').show();
    $('#saveAddress').hide();
    $('.modal-dialog').removeClass('show-suggested-address');
  }

  function submitAddressForm(action, isCallFromSuggestedAddressPopup) {
    var addressCheckboxData = '';

    if (action == 'editAddress') {
      var formURL = `${ACC.config.encodedContextPath}${API_REFERENCE.accountAddressBook.updateAddress}`;
    } else {
      var formURL = `${ACC.config.encodedContextPath}${API_REFERENCE.accountAddressBook.addNewAddress}`;
    }

    if (addressData.length <= 1) {
      $('.prefferredShippingAddress, .billingAddress').removeAttr('disabled');
    }

    if (!$(clsBillingAddress).is(':checked')) {
      addressCheckboxData = addressCheckboxData + '&billingAddress=' + false;
    }

    if (!$(clsPrefferredShippingAddress).is(':checked')) {
      addressCheckboxData =
        addressCheckboxData + '&isPreferredShippingAddress=' + false;
    }

    var submitFormUrl = formURL;
    var $form = $(document).find('.addEditAddressForm');
    window.testform = $form.serialize();
    const formDataToBeSubmitted = $form.serialize() + addressCheckboxData;
    if (isCallFromSuggestedAddressPopup) {
      if (!submitAddressBookAjaxReq) return false;
      submitAddressBookAjaxReq = false;
    }
    formPost(submitFormUrl, formDataToBeSubmitted)
      .then(data => {
        if (data == 'FAILURE') {
          $('.new-address-zip-value')
            .addClass('error-msg-textbox')
            .parent()
            .find('.invalid-zip-code-paste')
            .attr('hidden', false);
          addressBookValidateAjaxReq = true;
          return false;
        }

        if (!bReplaceWithNew) {
          // when simply creating new address
          location.reload();
        } else {
          // if coming from doRemoveAddNewAddress
          // retrieve the newly create id and do replace
          // reload will be done by doRemoveReplaceAddress & doUpdateDefaultAddress afterward
          if (!isEditing) {
            doRemoveReplaceAddress(removingCardId, data, true);
          } else {
            doUpdateDefaultAddress(
              updatingCardId,
              data,
              newDefaultCheckedType,
              true
            );
          }
        }
      })
      .catch(error => {
        if (isCallFromSuggestedAddressPopup) {
          submitAddressBookAjaxReq = true;
        } else {
          addressBookValidateAjaxReq = true;
        }
      });
  }

  function is_int(value) {
    if (parseFloat(value) == parseInt(value) && !isNaN(value)) {
      return true;
    } else {
      return false;
    }
  }

  function getCityAndState() {
    var zipCode = $(this);

    if (zipCode.val().length >= 5 && isValidZipVal) {
      var addressRequest = {};
      addressRequest.address1 = $('.new-address-addressline1').val();
      addressRequest.address2 = $('.new-address-addressline2').val();
      addressRequest.zip = $('.zip').val();
      var response = null;
      const addressRequestData = JSON.stringify(addressRequest);
      jsonPost(validateCustomerAddressUrl, addressRequestData).then(data => {
        response = data;
        if(response.city.trim() != ""){
            $('.new-address-city-value').val(response.city);
        }
        if(response.state.trim() != ""){
            $('.new-address-state-value').val(response.state);
        }
        $('.new-address-state-value').trigger('change');
        $('.new-address-city-value').trigger('change');
        if($('.new-address-state-value.checkout-address__dropdown').length > 0){
          $('.new-address-state-value.checkout-address__dropdown')
          .selectmenu('refresh')
          .trigger('selectmenuchange');
        }
        $('.new-address-state-value.address-book-state-value').selectmenu(
          'refresh'
        );
        $('#rdiVal').val(response.rdi);
      });
    }
  }

  function setSkipRemoveConfirmationModal() {
    if ($('#dont-ask').is(':checked')) {
      window.localStorage.setItem('removeAddressConfirm', false);
    } else {
      window.localStorage.setItem('removeAddressConfirm', true);
    }
  }

  function validationOnPaste(e) {
    let isInvalidZipCode;
    isInvalidZipCode = zipCodeValidator(e, $(this));
    $(this)
      .removeClass('error-msg-textbox')
      .parent()
      .find('.invalid-zip-code-paste')
      .attr('hidden', true);
    isValidZipVal = true;
    if (isInvalidZipCode && $(this).val() !== '') {
      $(this)
        .addClass('error-msg-textbox')
        .parent()
        .find('.invalid-zip-code-paste')
        .attr('hidden', false);
      isValidZipVal = false;
    }
  }

  $('.replace-with-new-address').on('change', function(e) {
    e.preventDefault();
    $('.next').attr('disabled', false);
  });
  $('.replace-with-existing-address').on('change', function(e) {
    e.preventDefault();
    $('.next').attr('disabled', true);
  });
  var elements = document.getElementsByClassName('custom-input-valid');
  $.each(elements, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidInput);
  });
  $('.add-address-img').on('click', newAddressData);
  const checkIE = /MSIE|Trident/.test(window.navigator.userAgent);
  if (checkIE) {
    $(document).on('click', '.add-address-btn', function(e) {
      const xIE = e.clientX;
      const yIE = e.clientY;
      if (xIE && yIE) {
        const elementMouseIE = document.elementFromPoint(xIE, yIE);
        elementMouseIE.click();
      }
    });
  }

  function createFocus() {
    if ($('#addressAction').val() === 'addAddress') {
      setTimeout(function() {
        $('.addNewAddress.add-address-btn').focus();
      }, 200);
    } else {
      setTimeout(function() {
        if (editingCard !== undefined) {
          editingCard.find('.address-modifier_edit').focus();
        } else {
          $(removingCard)
            .find('.address-modifier_remove')
            .focus();
        }
      }, 200);
    }
  }
  function resetEditingFlag() {
    isEditing = false;
  }
  function removeNewAddressDataEnter(e) {
    if (e.keyCode == 13) {
      $(this).trigger('click');
    }
  }
  function addNewAddressDataEnter(e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      $('.add-address-img').trigger('click');
    }
  }
  function editAddressEnter(e) {
    if (e.keyCode == 13) {
      $(this).trigger('click');
    }
  }

  function validateAddressLine(){ 
    isAddressLineVal = true ;
    if( $(this).val().trim() === '' || $(this).val().trim() === null){
      $(this).parent().find('.error-msg-text').attr('hidden', false);
      isAddressLineVal = false ;  
    }
  }

  function validateCity(){
    isCityVal = true ;
    if( $(this).val().trim() === '' || $(this).val().trim() === null){
      $(this).parent().find('.error-msg-text').attr('hidden', false);
      isCityVal = false ;  
    } else{
      $(this).parent().find('.error-msg-text').attr('hidden', true);
      $(this).removeClass(clsErrorText);
      $(this).removeClass('error-msg-textbox');
      isCityVal = true ;
    }
  }
  $(document).on('change' , '.new-address-addressline1-value', validateAddressLine);
  $(document).on('change' , '.new-address-city-value', validateCity);
  $(document).on(
    'click',
    '.page-viewaddressbook .cancel-edit-address,.page-viewaddressbook .addEditModal #cboxClose',
    resetEditingFlag
  );
  $('.address-book').on('click', '.edit', editAddress);
  $('.address-book').on('keyup', '.edit', editAddressEnter);
  $('.address-book').on('click', '.remove', removeNewAddressData);
  $('.address-book').on('keyup', '.remove', removeNewAddressDataEnter);
  $(document).on('keyup', '.add-address-btn', addNewAddressDataEnter);
  $('.remove-popup').on('click', remove);
  $('body').delegate('.cancel, .custom-close-btn', 'click', cancelState);
  $('body').delegate('#btn-cancel-save', 'click', closeSaveAddressModal);
  $('body').delegate('#btn-save-address', 'click', saveAddress);
  $(document).on('change', '.new-address-zip-value', validationOnPaste);
  $('body').on(
    'input',
    '#addNewAddress .zip,.checkout-add-edit-address__form .zip',
    validationOnPaste
  );
  $('body').on(
    'input',
    '#addNewAddress .zip,.checkout-add-edit-address__form .zip',
    getCityAndState
  );
  $(document).on('input', '.custom-input-valid', validateInput);
  $(document).on(
    'selectmenuchange',
    'select.new-address-state-value',
    validateInput
  );
  $(document).on('submit', '.addEditAddressForm', validateAddress);
  $(document).on('click', '#newadd', function() {
    $('.remove-adress--btn .btn-confirm').removeAttr('disabled', 'disabled');
  });
  $('body').delegate(
    '.addEditModal #cboxClose, .dismiss-modal, .removeReplaceModal  #cboxClose',
    'click',
    createFocus
  );

  function saveData() {
    $('#addnewaddress').show();
    $('#saveAddress').hide();
    $('.new-address.show').css({
      'padding-left': '48px',
      'padding-right': '48px'
    });
    $('#colorbox.suggestedAddressModal').addClass('addEditModal');
    triggerResize();
  }

  $(document).on('click', '#btn-edit-address', saveData);
  $('body').on('change', 'input[name="address-replacement"]', function() {
    if ($(this).val() == 'new-address') {
      $('.btn-confirm-address-removal').text('Next');
    } else {
      $('.btn-confirm-address-removal').text('Submit');
    }
  });
  $(window).resize(function() {
    if ($('#colorbox').is(':visible')) {
      setTimeout(function() {
        $.colorbox.resize();
      }, 100);
    }
  });
  numCards = $('.card-default').not('.new-card');
});
